import { DashboardData } from "@/domain/entities/Dashboard";

export const dashboardConsoleData: Array<DashboardData> = [
  // incoming
  {
    title: "dashboard.console.allStt.cardTitles.sttNotReceived",
    key: "incomingNotReceived",
    accountType: "console",
    type: "incoming-received",
    status: "",
    loading: true,
    error: false,
    icon: "arrow-down",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingNotReceived"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoPlane",
    key: "incomingCargoPlane",
    accountType: "console",
    type: "incoming-received",
    status: "CARGO PLANE",
    loading: true,
    error: false,
    icon: "cargo-plane",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingCargoPlane"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoTruck",
    key: "incomingCargoTruck",
    accountType: "console",
    type: "incoming-received",
    status: "CARGO TRUCK",
    loading: true,
    error: false,
    icon: "cargo-truck",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingCargoTruck"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoTrain",
    key: "incomingCargoTrain",
    accountType: "console",
    type: "incoming-received",
    status: "CARGO TRAIN",
    loading: true,
    error: false,
    icon: "cargo-train",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingCargoTrain"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttTransit",
    key: "incomingTransit",
    accountType: "console",
    type: "incoming-received",
    status: "TRANSIT",
    loading: true,
    error: false,
    icon: "transit",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingTransit"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttMisroute",
    key: "incomingMisroute",
    accountType: "console",
    type: "incoming-received",
    status: "MIS-ROUTE",
    loading: true,
    error: false,
    icon: "misroute",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingMisroute"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttShortland",
    key: "incomingShortland",
    accountType: "console",
    type: "incoming-received",
    status: "SHORTLAND",
    loading: true,
    error: false,
    icon: "shortland",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingShortland"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttNotFinished",
    key: "incomingNotFinished",
    accountType: "console",
    type: "incoming-not-finished",
    status: "",
    loading: true,
    error: false,
    icon: "pod-dex",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingNotFinished"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttStiDest",
    key: "incomingStiDest",
    accountType: "console",
    type: "incoming-not-finished",
    status: "STI-DEST",
    loading: true,
    error: false,
    icon: "sti-dest",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingStiDest"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttStiDestSc",
    key: "incomingStiDestSc",
    accountType: "console",
    type: "incoming-not-finished",
    status: "STI DEST-SC",
    loading: true,
    error: false,
    icon: "sti-dest-sc",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingStiDestSc"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttDel",
    key: "incomingDel",
    accountType: "console",
    type: "incoming-not-finished",
    status: "DEL",
    loading: true,
    error: false,
    icon: "delivery",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingDel"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttDex",
    key: "incomingDex",
    accountType: "console",
    type: "incoming-not-finished",
    status: "DEX",
    loading: true,
    error: false,
    icon: "dex",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingDex"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttHal",
    key: "incomingHal",
    accountType: "console",
    type: "incoming-not-finished",
    status: "HAL",
    loading: true,
    error: false,
    icon: "hal",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.incomingHal"
  },

  // transit
  {
    title: "dashboard.console.allStt.cardTitles.sttNotReceived",
    key: "transitUndelivered",
    accountType: "console",
    type: "transit_undelivered",
    status: "",
    loading: true,
    error: false,
    icon: "arrow-up",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.transitUndelivered"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoPlane",
    key: "transitUndelivered",
    accountType: "console",
    type: "transit_undelivered",
    status: "CARGO PLANE",
    loading: true,
    error: false,
    icon: "cargo-plane",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.transitUndeliveredCargoPlane"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoTruck",
    key: "transitUndelivered",
    accountType: "console",
    type: "transit_undelivered",
    status: "CARGO TRUCK",
    loading: true,
    error: false,
    icon: "cargo-truck",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.transitUndeliveredCargoTruck"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoTrain",
    key: "transitUndelivered",
    accountType: "console",
    type: "transit_undelivered",
    status: "CARGO TRAIN",
    loading: true,
    error: false,
    icon: "cargo-train",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.transitUndeliveredCargoTrain"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttNotFinished",
    key: "transitUnfinished",
    accountType: "console",
    type: "transit_unfinished",
    status: "",
    loading: true,
    error: false,
    icon: "pod-dex",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.transitUnfinished"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoPlane",
    key: "transitUnfinished",
    accountType: "console",
    type: "transit_unfinished",
    status: "CARGO PLANE",
    loading: true,
    error: false,
    icon: "cargo-plane",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.transitUnfinishedCargoPlane"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoTruck",
    key: "transitUnfinished",
    accountType: "console",
    type: "transit_unfinished",
    status: "CARGO TRUCK",
    loading: true,
    error: false,
    icon: "cargo-truck",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.transitUnfinishedCargoTruck"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoTrain",
    key: "transitUnfinished",
    accountType: "console",
    type: "transit_unfinished",
    status: "CARGO TRAIN",
    loading: true,
    error: false,
    icon: "cargo-train",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.transitUnfinishedCargoTrain"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttTransit",
    key: "transitUnfinished",
    accountType: "console",
    type: "transit_unfinished",
    status: "TRANSIT",
    loading: true,
    error: false,
    icon: "transit",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.transitUnfinishedTransit"
  },

  // outgoing
  {
    title: "dashboard.console.allStt.cardTitles.sttNotReceived",
    key: "outgoingNotReceived",
    accountType: "console",
    type: "outgoing-received",
    status: "",
    loading: true,
    error: false,
    icon: "arrow-up",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingNotReceived"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttBkd",
    key: "outgoingBkd",
    accountType: "console",
    type: "outgoing-received",
    status: "BKD",
    loading: true,
    error: false,
    icon: "bkd",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingBkd"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttPup",
    key: "outgoingPup",
    accountType: "console",
    type: "outgoing-received",
    status: "PUP",
    loading: true,
    error: false,
    icon: "shipment",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingPup"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttStiSc",
    key: "outgoingStiSc",
    accountType: "console",
    type: "outgoing-received",
    status: "STI-SC",
    loading: true,
    error: false,
    icon: "sti-sc",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingStiSc"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttNotFinished",
    key: "outgoingNotFinished",
    accountType: "console",
    type: "outgoing-not-finished",
    status: "",
    loading: true,
    error: false,
    icon: "pod-dex",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingNotFinished"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttSti",
    key: "outgoingSti",
    accountType: "console",
    type: "outgoing-not-finished",
    status: "STI",
    loading: true,
    error: false,
    icon: "sti",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingSti"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttBagging",
    key: "outgoingBagging",
    accountType: "console",
    type: "outgoing-not-finished",
    status: "BAGGING",
    loading: true,
    error: false,
    icon: "bagging",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingBagging"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttShortland",
    key: "outgoingShortland",
    accountType: "console",
    type: "outgoing-not-finished",
    status: "SHORTLAND",
    loading: true,
    error: false,
    icon: "shortland",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingShortland"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoPlane",
    key: "outgoingCargoPlane",
    accountType: "console",
    type: "outgoing-not-finished",
    status: "CARGO PLANE",
    loading: true,
    error: false,
    icon: "cargo-plane",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingCargoPlane"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoTruck",
    key: "outgoingCargoTruck",
    accountType: "console",
    type: "outgoing-not-finished",
    status: "CARGO TRUCK",
    loading: true,
    error: false,
    icon: "cargo-truck",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingCargoTruck"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttCargoTrain",
    key: "outgoingCargoTrain",
    accountType: "console",
    type: "outgoing-not-finished",
    status: "CARGO TRAIN",
    loading: true,
    error: false,
    icon: "cargo-train",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingCargoTrain"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttMisroute",
    key: "outgoingMisroute",
    accountType: "console",
    type: "outgoing-not-finished",
    status: "MIS-ROUTE",
    loading: true,
    error: false,
    icon: "misroute",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingMisroute"
  },
  {
    title: "dashboard.console.allStt.cardTitles.sttRejected",
    key: "outgoingRejected",
    accountType: "console",
    type: "outgoing-not-finished",
    status: "REJECTED",
    loading: true,
    error: false,
    icon: "rejected",
    totalStt: 0,
    description: "dashboard.console.allStt.cardDescriptions.outgoingRejected"
  }
];

export const CutOffConsoleOutgoingSttData = [
  // cycle 1
  {
    title: "dashboard.console.currentStt.cutOffTitles.cycle1",
    description: "dashboard.console.currentStt.cutOffDescriptions.cycle",
    key: "total",
    section: "cycle1",
    type: "outgoing",
    status: "",
    icon: "outgoing-current-stt",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  // {
  //   title: "Perlu di STI",
  //   detailTitle: "On Process",
  //   key: "bkdSti",
  //   section: "cycle1",
  //   type: "outgoing",
  //   status: "on_process_bkd_to_sti_cycle_1",
  //   icon: "bkd-to-sti",
  //   totalStt: 0,
  //   start: "cycleStart",
  //   endKey: "targetSti",
  //   end: ""
  // },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needCargoPlane",
    detailTitle: "On Process",
    key: "stiCargoPlane",
    section: "cycle1",
    type: "outgoing",
    status: "on_process_sti_to_cargo_plane_cycle1",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "dc1_need_cargo_flight",
    start: "targetSti",
    endKey: "cycleEndCargoPlane",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needCargoTruckTrain",
    detailTitle: "On Process",
    key: "stiCargoTruck",
    section: "cycle1",
    type: "outgoing",
    status: "on_process_sti_to_cargo_truck_cycle1",
    icon: "cargo-train",
    totalStt: 0,
    gtmEventName: "dc1_need_cargo_truck/train",
    start: "targetSti",
    endKey: "cycleEndCargoTruck",
    end: ""
  },
  // cycle 2
  {
    title: "dashboard.console.currentStt.cutOffTitles.cycle2",
    description: "dashboard.console.currentStt.cutOffDescriptions.cycle",
    key: "total",
    section: "cycle2",
    type: "outgoing",
    status: "",
    icon: "outgoing-current-stt",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  // {
  //   title: "Perlu di STI",
  //   detailTitle: "On Process",
  //   key: "bkdSti",
  //   section: "cycle2",
  //   type: "outgoing",
  //   status: "on_process_bkd_to_sti_cycle_2",
  //   icon: "bkd-to-sti",
  //   totalStt: 0,
  //   start: "cycleStart",
  //   endKey: "targetSti",
  //   end: ""
  // },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needCargoPlane",
    detailTitle: "On Process",
    key: "stiCargoPlane",
    section: "cycle2",
    type: "outgoing",
    status: "on_process_sti_to_cargo_plane_cycle2",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "dc2_need_cargo_flight",
    start: "targetSti",
    endKey: "cycleEndCargoPlane",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needCargoTruckTrain",
    detailTitle: "On Process",
    key: "stiCargoTruck",
    section: "cycle2",
    type: "outgoing",
    status: "on_process_sti_to_cargo_truck_cycle2",
    icon: "cargo-train",
    totalStt: 0,
    gtmEventName: "dc2_need_cargo_truck/train",
    start: "targetSti",
    endKey: "cycleEndCargoTruck",
    end: ""
  },
  // backlog hari ini
  {
    title: "dashboard.console.currentStt.cutOffTitles.backlogToday",
    description: "dashboard.console.currentStt.cutOffDescriptions.backlogToday",
    key: "total",
    section: "backlogToday",
    type: "outgoing",
    status: "",
    icon: "backlog",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needSti",
    detailTitle: "Backlog",
    key: "bkdSti",
    section: "backlogToday",
    type: "outgoing",
    status: "backlog_bkd_to_sti_today",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needCargoPlane",
    detailTitle: "Backlog",
    key: "stiCargoPlane",
    section: "backlogToday",
    type: "outgoing",
    status: "backlog_sti_to_cargo_plane_today",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "backlog1_cargo_flight"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needCargoTruckTrain",
    detailTitle: "Backlog",
    key: "stiCargoTruck",
    section: "backlogToday",
    type: "outgoing",
    status: "backlog_sti_to_cargo_truck_today",
    icon: "cargo-train",
    totalStt: 0,
    gtmEventName: "backlog1_cargo_truck/train"
  },
  // backlog 2-7 hari
  {
    title: "dashboard.console.currentStt.cutOffTitles.backlog2to7",
    description: "dashboard.console.currentStt.cutOffDescriptions.backlog2to7",
    key: "total",
    section: "backlog",
    type: "outgoing",
    status: "",
    icon: "backlog",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needSti",
    detailTitle: "Backlog 2-7 Hari",
    key: "bkdSti",
    section: "backlog",
    type: "outgoing",
    status: "backlog_bkd_to_sti",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needCargoPlane",
    detailTitle: "Backlog 2-7 Hari",
    key: "stiCargoPlane",
    section: "backlog",
    type: "outgoing",
    status: "backlog_sti_to_cargo_plane",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "backlog2_cargo_flight"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needCargoTruckTrain",
    detailTitle: "Backlog 2-7 Hari",
    key: "stiCargoTruck",
    section: "backlog",
    type: "outgoing",
    status: "backlog_sti_to_cargo_truck",
    icon: "cargo-train",
    totalStt: 0,
    gtmEventName: "backlog2_cargo_truck/train"
  },
  // hanging
  {
    title: "dashboard.console.currentStt.cutOffTitles.hanging",
    description: "dashboard.console.currentStt.cutOffDescriptions.hanging",
    key: "total",
    section: "hanging",
    type: "outgoing",
    status: "",
    icon: "hanging",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.bkdToSti",
    detailTitle: "Hanging",
    key: "bkdSti",
    section: "hanging",
    type: "outgoing",
    status: "hanging_bkd_to_sti",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.stiToCargoPlane",
    detailTitle: "Hanging",
    key: "stiCargoPlane",
    section: "hanging",
    type: "outgoing",
    status: "hanging_sti_to_cargo_plane",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "hanging_cargo_flight"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.stiToCargoTruckTrain",
    detailTitle: "Hanging",
    key: "stiCargoTruck",
    section: "hanging",
    type: "outgoing",
    status: "hanging_sti_to_cargo_truck",
    icon: "cargo-train",
    totalStt: 0,
    gtmEventName: "hanging_cargo_truck/train"
  },
  // on time
  {
    title: "dashboard.console.currentStt.cutOffTitles.onTime",
    description: "dashboard.console.currentStt.cutOffDescriptions.onTime",
    key: "total",
    section: "onTime",
    type: "outgoing",
    status: "",
    icon: "input-manifest-dashboard",
    iconStatus: true,
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.bkdToSti",
    detailTitle: "On Time",
    key: "bkdSti",
    section: "onTime",
    type: "outgoing",
    status: "ontime_bkd_to_sti",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.stiToCargoPlane",
    detailTitle: "On Time",
    key: "stiCargoPlane",
    section: "onTime",
    type: "outgoing",
    status: "ontime_sti_to_cargo_plane",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "ontime_cargo_flight"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.stiToCargoTruckTrain",
    detailTitle: "On Time",
    key: "stiCargoTruck",
    section: "onTime",
    type: "outgoing",
    status: "ontime_sti_to_cargo_truck",
    icon: "cargo-train",
    totalStt: 0,
    gtmEventName: "ontime_cargo_truck/train"
  },
  // late
  {
    title: "dashboard.console.currentStt.cutOffTitles.late",
    description: "dashboard.console.currentStt.cutOffDescriptions.late",
    key: "total",
    section: "late",
    type: "outgoing",
    status: "",
    icon: "input-manifest-dashboard",
    iconStatus: false,
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.bkdToSti",
    detailTitle: "Late",
    key: "bkdSti",
    section: "late",
    type: "outgoing",
    status: "late_bkd_to_sti",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.stiToCargoPlane",
    detailTitle: "Late",
    key: "stiCargoPlane",
    section: "late",
    type: "outgoing",
    status: "late_sti_to_cargo_plane",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "late_cargo_flight"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.stiToCargoTruckTrain",
    detailTitle: "Late",
    key: "stiCargoTruck",
    section: "late",
    type: "outgoing",
    status: "late_sti_to_cargo_truck",
    icon: "cargo-train",
    totalStt: 0,
    gtmEventName: "late_cargo_truck/train"
  },
  // invalid
  {
    title: "dashboard.console.currentStt.cutOffTitles.invalidSkippingStatus",
    detailTitle: "",
    description: "dashboard.console.currentStt.cutOffDescriptions.invalid",
    key: "invalid",
    section: "invalid",
    type: "outgoing",
    status: "total_stt_invalid",
    icon: "invalid-dashboard",
    totalStt: 0,
    gtmEventName: "outgoing_invalid"
  },
  // incoming
  // cycle 1
  {
    title: "dashboard.console.currentStt.cutOffTitles.cycle1",
    description:
      "dashboard.console.currentStt.cutOffDescriptions.cycle1Incoming",
    key: "total",
    section: "cycle1",
    type: "incoming",
    status: "",
    icon: "incoming-current-stt",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needDel",
    detailTitle: "On Process",
    key: "stiDestDel",
    section: "cycle1",
    type: "incoming",
    status: "on_process_sti_dest_to_del_cycle_1",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: "cylce1_need_DEL",
    start: "cycleStart",
    endKey: "targetDel",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needPod",
    detailTitle: "On Process",
    key: "delPod",
    section: "cycle1",
    type: "incoming",
    status: "on_process_del_to_pod_cycle_1",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "cylce1_need_POD",
    start: "targetDel",
    endKey: "targetPod",
    end: ""
  },
  // cycle 2
  {
    title: "dashboard.console.currentStt.cutOffTitles.cycle2",
    description:
      "dashboard.console.currentStt.cutOffDescriptions.cycle2Incoming",
    key: "total",
    section: "cycle2",
    type: "incoming",
    status: "",
    icon: "incoming-current-stt",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needDel",
    detailTitle: "On Process",
    key: "stiDestDel",
    section: "cycle2",
    type: "incoming",
    status: "on_process_sti_dest_to_del_cycle_2",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: "cylce2_need_DEL",
    start: "cycleStart",
    endKey: "targetDel",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needPod",
    detailTitle: "On Process",
    key: "delPod",
    section: "cycle2",
    type: "incoming",
    status: "on_process_del_to_pod_cycle_2",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "cylce2_need_POD",
    start: "targetDel",
    endKey: "targetPod",
    end: ""
  },
  // backlog hari ini
  {
    title: "dashboard.console.currentStt.cutOffTitles.backlogToday",
    description: "dashboard.console.currentStt.cutOffDescriptions.backlogToday",
    key: "total",
    section: "backlogToday",
    type: "incoming",
    status: "",
    icon: "backlog",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needDel",
    detailTitle: "Backlog",
    key: "stiDestDel",
    section: "backlogToday",
    type: "incoming",
    status: "backlog_sti_dest_to_del_today",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: "backlog1_DEL"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needPod",
    detailTitle: "Backlog",
    key: "delPod",
    section: "backlogToday",
    type: "incoming",
    status: "backlog_del_to_pod_today",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "backlog1_POD"
  },
  // backlog 2-7 hari
  {
    title: "dashboard.console.currentStt.cutOffTitles.backlog2to7",
    description: "dashboard.console.currentStt.cutOffDescriptions.backlog2to7",
    key: "total",
    section: "backlog",
    type: "incoming",
    status: "",
    icon: "backlog",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needDel",
    detailTitle: "Backlog 2-7 Hari",
    key: "stiDestDel",
    section: "backlog",
    type: "incoming",
    status: "backlog_sti_dest_to_del",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: "backlog2_DEL"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needPod",
    detailTitle: "Backlog 2-7 Hari",
    key: "delPod",
    section: "backlog",
    type: "incoming",
    status: "backlog_del_to_pod",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "backlog2_POD"
  },
  // hanging
  {
    title: "dashboard.console.currentStt.cutOffTitles.hanging",
    description: "dashboard.console.currentStt.cutOffDescriptions.hanging",
    key: "total",
    section: "hanging",
    type: "incoming",
    status: "",
    icon: "hanging",
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needDel",
    detailTitle: "Hanging",
    key: "stiDestDel",
    section: "hanging",
    type: "incoming",
    status: "hanging_sti_dest_to_del",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: "hanging_DEL"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needPod",
    detailTitle: "Hanging",
    key: "delPod",
    section: "hanging",
    type: "incoming",
    status: "hanging_del_to_pod",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "hanging_POD"
  },
  // on time
  {
    title: "dashboard.console.currentStt.cutOffTitles.onTime",
    description: "dashboard.console.currentStt.cutOffDescriptions.onTime",
    key: "total",
    section: "onTime",
    type: "incoming",
    status: "",
    icon: "input-manifest-dashboard",
    iconStatus: true,
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needDel",
    detailTitle: "On Time",
    key: "stiDestDel",
    section: "onTime",
    type: "incoming",
    status: "ontime_sti_dest_to_del",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: "ontime_DEL"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needPod",
    detailTitle: "On Time",
    key: "delPod",
    section: "onTime",
    type: "incoming",
    status: "ontime_del_to_pod",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "ontime_POD"
  },
  // late
  {
    title: "dashboard.console.currentStt.cutOffTitles.late",
    description: "dashboard.console.currentStt.cutOffDescriptions.late",
    key: "total",
    section: "late",
    type: "incoming",
    status: "",
    icon: "input-manifest-dashboard",
    iconStatus: false,
    totalStt: 0,
    gtmEventName: "",
    start: "",
    endKey: "",
    end: ""
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needDel",
    detailTitle: "Late",
    key: "stiDestDel",
    section: "late",
    type: "incoming",
    status: "late_sti_dest_to_del",
    icon: "bkd-to-sti",
    totalStt: 0,
    gtmEventName: "late_DEL"
  },
  {
    title: "dashboard.console.currentStt.cutOffTitles.needPod",
    detailTitle: "Late",
    key: "delPod",
    section: "late",
    type: "incoming",
    status: "late_del_to_pod",
    icon: "cargo-plane",
    totalStt: 0,
    gtmEventName: "late_POD"
  },
  // invalid
  {
    title: "dashboard.console.currentStt.cutOffTitles.invalidSkippingStatus",
    detailTitle: "",
    description: "dashboard.console.currentStt.cutOffDescriptions.invalid",
    key: "invalid",
    section: "invalid",
    type: "incoming",
    status: "total_stt_invalid",
    icon: "invalid-dashboard",
    totalStt: 0,
    gtmEventName: "incoming_invalid"
  }
];
